<ion-header>
  <ion-toolbar>
    <ion-title>
      {{ companyId ? "Firma bearbeiten" : "Firma erstellen" }}
    </ion-title>

    @if(!state.isBigScreen){
    <ion-buttons slot="start">
      <ion-button type="button" (click)="cancel()" [disabled]="saving">
        <ion-icon
          name="arrow-back-outline"
          slot="icon-only"
        ></ion-icon> </ion-button
    ></ion-buttons>
    } @if(state.isBigScreen){
    <ion-buttons slot="end">
      <ion-button type="button" (click)="cancel()" [disabled]="saving">
        <ion-icon name="close-outline" slot="icon-only"></ion-icon>
      </ion-button> </ion-buttons
    >}
  </ion-toolbar>
</ion-header>

<ion-content>
  <form [formGroup]="form" (ngSubmit)="save()">
    <!-- Stammdaten -->
    <ion-list>
      <!-- Name -->
      <ion-item
        [class.ion-invalid]="hasError('name')"
        [class.ion-touched]="hasError('name')"
      >
        <ion-input
          formControlName="name"
          label="Name *"
          labelPlacement="floating"
          fill="outline"
          mode="md"
          type="text"
          autocomplete="organization"
        >
        </ion-input>
      </ion-item>

      <ion-note class="error-message" *ngIf="hasError('name')">
        Der Name ist erforderlich.
      </ion-note>

      <!-- Company Number -->
      <ion-item>
        <ion-input
          formControlName="companyNumber"
          label="Firmennummer"
          labelPlacement="floating"
          fill="outline"
          mode="md"
          type="text"
        >
        </ion-input>
      </ion-item>

      <!-- Address -->
      <ion-item
        [class.ion-invalid]="hasError('address')"
        [class.ion-touched]="hasError('address')"
      >
        <ion-input
          formControlName="address"
          label="Adresse *"
          labelPlacement="floating"
          fill="outline"
          mode="md"
          type="text"
          autocomplete="street-address"
        >
        </ion-input>
      </ion-item>

      <ion-note class="error-message" *ngIf="hasError('address')">
        Die Adresse ist erforderlich.
      </ion-note>

      <!-- Postal Code -->
      <ion-item
        [class.ion-invalid]="hasError('postalCode')"
        [class.ion-touched]="hasError('postalCode')"
      >
        <ion-input
          formControlName="postalCode"
          label="Postleitzahl *"
          labelPlacement="floating"
          fill="outline"
          mode="md"
          type="text"
          inputmode="numeric"
          autocomplete="postal-code"
        >
        </ion-input>
      </ion-item>

      <ion-note class="error-message" *ngIf="hasError('postalCode')">
        Die Postleitzahl ist erforderlich.
      </ion-note>

      <!-- City -->
      <ion-item
        [class.ion-invalid]="hasError('city')"
        [class.ion-touched]="hasError('city')"
      >
        <ion-input
          formControlName="city"
          label="Stadt *"
          labelPlacement="floating"
          fill="outline"
          mode="md"
          type="text"
          autocomplete="address-level2"
        >
        </ion-input>
      </ion-item>

      <ion-note class="error-message" *ngIf="hasError('city')">
        Die Stadt ist erforderlich.
      </ion-note>

      <!-- State -->
      <ion-item
        [class.ion-invalid]="hasError('state')"
        [class.ion-touched]="hasError('state')"
      >
        <ion-select
          formControlName="state"
          label="Bundesland *"
          labelPlacement="floating"
          fill="outline"
          mode="md"
          interface="popover"
          placeholder="Bundesland auswählen"
        >
          <ion-select-option
            *ngFor="let state of germanStates"
            [value]="state.code"
          >
            {{ state.name }}
          </ion-select-option>
        </ion-select>
      </ion-item>

      <ion-note class="error-message" *ngIf="hasError('state')">
        Das Bundesland ist erforderlich.
      </ion-note>

      <!-- E-Mail -->
      <ion-item
        [class.ion-invalid]="hasError('mail')"
        [class.ion-touched]="hasError('mail')"
      >
        <ion-input
          formControlName="mail"
          label="E-Mail"
          labelPlacement="floating"
          fill="outline"
          mode="md"
          type="email"
          autocomplete="email"
        >
        </ion-input>
      </ion-item>

      <ion-note class="error-message" *ngIf="hasError('mail')">
        Bitte eine gültige E-Mail-Adresse eingeben.
      </ion-note>

      <!-- Phone -->
      <ion-item>
        <ion-input
          formControlName="phone"
          label="Telefon"
          labelPlacement="floating"
          fill="outline"
          mode="md"
          type="tel"
          autocomplete="tel"
        >
        </ion-input>
      </ion-item>

      <ion-item>
        <ion-input
          formControlName="basicAccounting"
          label="Stunden-Abrechnungs-Nummer"
          labelPlacement="floating"
          fill="outline"
          mode="md"
          type="text"
        >
        </ion-input>
      </ion-item>

      <ion-item>
        <ion-input
          formControlName="badWeatherAccounting"
          label="Schlechtwetter-Abrechnungs-Nummer"
          labelPlacement="floating"
          fill="outline"
          mode="md"
          type="text"
        >
        </ion-input>
      </ion-item>

      <ion-item>
        <ion-input
          formControlName="publicHolidayAccounting"
          label="Feiertags-Abrechnungs-Nummer"
          labelPlacement="floating"
          fill="outline"
          mode="md"
          type="text"
        >
        </ion-input>
      </ion-item>

      <ion-item>
        <ion-input
          formControlName="sicknessAccounting"
          label="Krankheits-Abrechnungs-Nummer"
          labelPlacement="floating"
          fill="outline"
          mode="md"
          type="text"
        >
        </ion-input>
      </ion-item>

      <ion-item>
        <ion-input
          formControlName="vacationAccounting"
          label="Urlaubs-Abrechnungs-Nummer"
          labelPlacement="floating"
          fill="outline"
          mode="md"
          type="text"
        >
        </ion-input>
      </ion-item>

      <ion-item>
        <ion-textarea
          formControlName="defaultConSiteFolders"
          label="Standard Baustellen-Ordner"
          labelPlacement="floating"
          fill="outline"
          mode="md"
          placeholder="Ordner1, Ordner2, Ordner3"
          autoGrow="true"
        >
        </ion-textarea>
      </ion-item>

      <ion-note class="field-hint">
        Mehrere Ordner können durch Kommas getrennt angegeben werden.
      </ion-note>
    </ion-list>

    <!-- Actions -->
    <div class="actions">
      <ion-button
        type="button"
        fill="outline"
        expand="block"
        (click)="cancel()"
        [disabled]="saving"
      >
        Abbrechen
      </ion-button>

      <ion-button type="submit" expand="block" [disabled]="saving">
        <span *ngIf="!saving">
          {{ companyId ? "Änderungen speichern" : "Firma erstellen" }}
        </span>
      </ion-button>
    </div>
  </form>
</ion-content>
